import axios from 'axios'

export const getUserData = (token: string) => axios.get(`${process.env.REACT_APP_API_URL}/portal-parceiros/login`, { headers: { Authorization: `Bearer ${token}` }}) 